import React, { useState, useRef, useEffect } from "react";
import TopNavbar from '../../../../components/TopNavbar';
import SideNavbar from '../../../../components/SideNavbar';
import { useNavigate } from "react-router-dom";
import countriesData from '../../../../Assets/Countries.json';
import { useAppSelector } from '../../../../redux/store';

// Firebase
import { functions } from '../../../../firebaseConfig'; // Adjust the path based on your project structure
import { httpsCallable } from 'firebase/functions';
import Toast from "../../../../components/Toast";

interface CountryData {
  currency: string[];
  callingCode: string[];
  region: string;
  subregion: string;
  flag: string;
  name: {
    common: string;
    [key: string]: string;
  };
}

interface CountriesData {
  [key: string]: CountryData;
}

const AccountNewCustomer = () => {
  const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);
  const [activeSection, setActiveSection] = useState("Invoices");
  const [activeSections, setActiveSections] = useState("New Customer");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDisplayNameDropdownOpen, setIsDisplayNameDropdownOpen] = useState(false);
  const [displayName, setDisplayName] = useState("Default");
  const [isGSTDropdownOpen, setIsGSTDropdownOpen] = useState(false);
  const [isPlaceDropdownOpen, setIsPlaceDropdownOpen] = useState(false);
  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const [isPaymentTermsDropdownOpen, setIsPaymentTermsDropdownOpen] = useState(false);
  const [isPortalLanguageOpen, setIsPortalLanguageOpen] = useState(false);
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
  const [countryCode, setCountryCode] = useState("IN");
  const [countries, setCountries] = useState<{ code: string; name: string; }[]>([]);
  const currencyRef = useRef<HTMLDivElement>(null);
  const paymentTermsRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const displayNameRef = useRef<HTMLDivElement>(null);
  const gstRef = useRef<HTMLDivElement>(null);
  const placeRef = useRef<HTMLDivElement>(null);
  const portalLanguageRef = useRef<HTMLDivElement>(null);
  const countryRef = useRef<HTMLDivElement>(null);
  const stateRef = useRef<HTMLDivElement>(null);
  const stateOptions = ["Karnataka", "Tamil Nadu", "Kerala", "Maharashtra", "Delhi", "Gujarat"];
  const [filteredSalutations, setFilteredSalutations] = useState(["Mrs", "Mr", "Ms"]);
  const displayNameOptions = ["Default", "Custom1", "Custom2"];
  const gstOptions = ["Registered Business", "Unregistered Business", "Consumer", "Overseas"];
  const placeOptions = ["Karnataka", "Tamil Nadu", "Kerala", "Andhra Pradesh", "Telangana"];
  const currencyOptions = ["INR - Indian Rupee", "USD - US Dollar", "EUR - Euro", "GBP - British Pound"];
  const paymentTermsOptions = ["Due on Receipt", "Net 15", "Net 30", "Net 45", "Net 60"];
  const languageOptions = ["English", "Spanish", "French", "German"];
  const countryOptions = ["India", "USA", "UK", "Canada", "Australia"];

  const navigate = useNavigate();

  const [customerType, setCustomerType] = useState("Business");
  const [salutation, setSalutation] = useState("Mrs");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [workNumber, setWorkNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [gstTreatment, setGSTTreatment] = useState("Registered Business");
  const [placeOfSupply, setPlaceOfSupply] = useState("Karnataka");
  const [pan, setPan] = useState("");
  const [taxable, setTaxable] = useState(true);
  const [currency, setCurrency] = useState("INR - Indian Rupee");
  const [openingBal, setOpeningBal] = useState(0);
  const [paymentTerms, setPaymentTerms] = useState("Due on Receipt");
  const [enablePortal, setEnablePortal] = useState(false);
  const [portalLanguage, setPortalLanguage] = useState("English");
  const [attention, setAttention] = useState("");
  const [country, setCountry] = useState("India");
  const [primaryAddress, setPrimaryAddress] = useState("");
  const [secondaryAddress, setSecondaryAddress] = useState("");
  const [city, setCity] = useState("");
  const [selectedState, setSelectedState] = useState("Karnataka");
  const [billingPhoneNo, setBillingPhoneNo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isErrorToast, setIsErrorToast] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleCustomerTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCustomerType(value);
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = ["Mrs", "Mr", "Ms"].filter((salutation) =>
      salutation.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSalutations(filtered);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const handleSelectSalutation = (value: string) => {
    setSalutation(value);
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsDropdownOpen(false);
    }
  };
  const handleGSTDropdownToggle = () => {
    setIsGSTDropdownOpen(prev => !prev);
  };

  const handlePlaceDropdownToggle = () => {
    setIsPlaceDropdownOpen(prev => !prev);
  };

  const handleSelectGST = (value: string) => {
    setGSTTreatment(value);
    setIsGSTDropdownOpen(false);
  };

  const handleSelectPlace = (value: string) => {
    setPlaceOfSupply(value);
    setIsPlaceDropdownOpen(false);
  };
  const handleCurrencyDropdownToggle = () => {
    setIsCurrencyDropdownOpen(prev => !prev);
  };

  const handlePaymentTermsDropdownToggle = () => {
    setIsPaymentTermsDropdownOpen(prev => !prev);
  };

  const handleSelectCurrency = (value: string) => {
    setCurrency(value);
    setIsCurrencyDropdownOpen(false);
  };

  const handleSelectPaymentTerms = (value: string) => {
    setPaymentTerms(value);
    setIsPaymentTermsDropdownOpen(false);
  };
  const handlePortalLanguageToggle = () => {
    setIsPortalLanguageOpen(prev => !prev);
  };

  const handleSelectPortalLanguage = (value: string) => {
    setPortalLanguage(value);
    setIsPortalLanguageOpen(false);
  };

  const handleCountryToggle = () => {
    setIsCountryOpen(prev => !prev);
  };

  // const handleSelectCountry = (value: string) => {
  //   setCountry(value);
  //   setIsCountryOpen(false);
  // };
  const handleStateDropdownToggle = () => {
    setIsStateDropdownOpen(prev => !prev);
  };

  const handleSelectState = (value: string) => {
    setSelectedState(value);
    setIsStateDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (displayNameRef.current && !displayNameRef.current.contains(event.target as Node)) {
        setIsDisplayNameDropdownOpen(false);
      }
      if (gstRef.current && !gstRef.current.contains(event.target as Node)) {
        setIsGSTDropdownOpen(false);
      }
      if (placeRef.current && !placeRef.current.contains(event.target as Node)) {
        setIsPlaceDropdownOpen(false);
      }
      if (currencyRef.current && !currencyRef.current.contains(event.target as Node)) {
        setIsCurrencyDropdownOpen(false);
      }
      if (paymentTermsRef.current && !paymentTermsRef.current.contains(event.target as Node)) {
        setIsPaymentTermsDropdownOpen(false);
      }
      if (portalLanguageRef.current && !portalLanguageRef.current.contains(event.target as Node)) {
        setIsPortalLanguageOpen(false);
      }
      if (countryRef.current && !countryRef.current.contains(event.target as Node)) {
        setIsCountryOpen(false);
      }
      if (stateRef.current && !stateRef.current.contains(event.target as Node)) {
        setIsStateDropdownOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };


    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDisplayNameDropdownToggle = () => {
    setIsDisplayNameDropdownOpen((prev) => !prev);
  };

  const handleSelectDisplayName = (value: string) => {
    setDisplayName(value);
    setIsDisplayNameDropdownOpen(false);
  };

  const sections = ["Invoices", "Payouts", "Invoice List"];
  const buttons = ["New Customer", "New Invoice"];
  const handleSectionClick = (section: string) => {
    setActiveSection(section);
    switch (section) {
      case 'Invoices':
        navigate('/accounts');
        break;
      case 'Payouts':
        navigate('/accounts/payouts');
        break;
      case 'Invoice List':
        navigate('/accounts/invoicelist');
        break;
      default:
        break;
    }
  };

  const handleButtonClick = (button: string) => {
    setActiveSections(button);
    switch (button) {
      case "New Customer":
        navigate("/accounts");
        break;
      case "New Invoice":
        navigate("/accounts/invoice");
        break;
      default:
        break;
    }
  };

  const getInputContainerClass = (numColumns: number) => {
    switch (numColumns) {
      case 1:
        return "w-[30%]";
      case 2:
        return "grid grid-cols-2 gap-6 w-[70%]";
      case 3:
        return "grid grid-cols-3 gap-6 w-[90%]";
      default:
        return "w-3/4";
    }
  };
  const inputClass = "w-full py-3 px-4 bg-white border-0 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600  transition duration-200";
  const gradientBorderStyles = {
    background: 'linear-gradient(white, white) padding-box, linear-gradient(180deg, #3483BE 0%, #02385E 100%) border-box',
    border: '1px solid transparent',
    borderRadius: '24px'
  };
  const labelClass = "block font-montserrat font-normal text-base text-black mb-2";

  // Firebase function to add a new customer
  const handleSave = async () => {
    if (isLoading) return;
  
    setIsLoading(true);
    try {
      const addCustomer = httpsCallable(functions, 'customerAccountRegistration');
      
      const result = await addCustomer({
        customerType: customerType,
        salutation: salutation,
        firstName: firstName,
        lastName: lastName,
        companyName: companyName,
        displayName: displayName,
        email: email,
        workNumber: workNumber,
        mobileNumber: mobileNumber,
        gstTreatment: gstTreatment,
        placeOfSupply: placeOfSupply,
        pan: pan,
        taxable: taxable,
        currency: currency,
        openingBal: openingBal,
        paymentTerms: paymentTerms,
        enablePortal: enablePortal,
        portalLanguage: portalLanguage,
        attention: attention,
        countryName: country,
        countryCode: countryCode,
        primaryAddress: primaryAddress,
        secondaryAddress: secondaryAddress,
        city: city,
        state: selectedState,
        billingPhoneNo: billingPhoneNo
      });
      setToastMessage('Customer added successfully!');
      setIsErrorToast(false);
      setShowToast(true);

      console.log(result.data);
    } catch (error) {
      setToastMessage('Failed to add customer. Please try again.');
      setIsErrorToast(true);
      setShowToast(true);

      console.error('Error adding customer:', error);
    }
  };
  useEffect(() => {
    const formattedCountries = Object.entries(countriesData as CountriesData).map(([code, data]) => ({
      code,
      name: data.name.common
    }));
    
    // Sort countries by name
    formattedCountries.sort((a, b) => a.name.localeCompare(b.name));
    setCountries(formattedCountries);
  }, []);

  const handleSelectCountry = (code: string, name: string) => {
    setCountry(name);
    setCountryCode(code);
    setIsCountryOpen(false);
  };
  return (
    <div className="min-h-screen bg-gray-200">
      {/* <div className="fixed top-0 left-0 w-full z-20">
        <TopNavbar />
      </div> */}
      <div className="fixed top-16 left-0 h-full z-10">
        <SideNavbar />
      </div>
      <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
        <div className="bg-white p-6 rounded-3xl shadow-md w-full min-h-screen flex flex-col">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full"
                style={{ background: "linear-gradient(180deg, #00A6D9 10%, #3483BE 100%)", }}>
                <img src={`${process.env.PUBLIC_URL}/images/desktop/basil_invoice-outline.svg`} alt="Icon" className="w-7 h-7" />
              </div>
              {sections.map((section) => (
                <h2
                  key={section}
                  onClick={() => handleSectionClick(section)}
                  className={`font-montserrat text-lg font-medium cursor-pointer ${activeSection === section ? "text-gray-900" : "text-stone-300"
                    }`}
                  style={{
                    borderBottom: activeSection === section ? "2px solid transparent" : "none",
                    backgroundImage: activeSection === section
                      ? "linear-gradient(180deg, #00A6D9 0%, #3483BE 100%)"
                      : "none",
                    backgroundPosition: "bottom",
                    backgroundSize: "100% 2px",
                    backgroundRepeat: "no-repeat"
                  }}
                >
                  {section}
                </h2>
              ))}
            </div>
          </div>
          <div className="px-6">
            <div className="flex space-x-2 mt-6">
              {buttons.map((button) => (
                <button key={button} onClick={() => handleButtonClick(button)}
                  className={`py-2 px-4 rounded-3xl text-center flex-shrink-0 ${activeSections === button ? 'bg-sky-950 font-montserrat font-normal text-[16px] text-white' : 'bg-gray-100 text-gray-900'}`}>
                  {button}
                </button>
              ))}
            </div>
            <div className="mt-6">
              <h3 className="font-montserrat-medium text-2xl font-gray-900 mb-4"> New Customer              </h3>
              <div className="mb-6">
                <h4 className="font-montserrat-normal text-xl  font-gray-900 mb-2">Customer Type</h4>
                <div className="flex items-center mt-6 space-x-6">
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="customerType" value={'Business'} className="w-6 h-6" defaultChecked onClick={() => handleCustomerTypeChange} />
                    <span className="font-montserrat text-base  font-gray-900">Business</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="customerType" value={'Individual'} className="w-6 h-6" onClick={() => handleCustomerTypeChange} />
                    <span className="font-montserrat text-base  font-gray-900">Individual</span>
                  </label>
                </div>
              </div>
              <div className="mb-6">
                <h4 className="font-montserrat-normal text-xl  font-gray-900 mb-4">Primary Contact</h4>
                <div className={getInputContainerClass(3)}>
                  <div>
                    <label htmlFor="salutation" className={labelClass}>Salutation</label>
                    <div className="relative">
                      <div>
                        <input ref={inputRef}
                          type="text"
                          value={salutation}
                          onClick={handleDropdownToggle}
                          onChange={handleSearchChange} className={inputClass} style={gradientBorderStyles} placeholder="Select Salutation" />
                      </div>
                      <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2" onClick={handleDropdownToggle}>
                        <img
                          src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`} alt="Dropdown Arrow"
                          className={`w-7 h-7 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                      </button>
                      {isDropdownOpen && (
                        <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10" ref={dropdownRef}>
                          {filteredSalutations.map((item) => (
                            <div key={item}
                              className="px-4 py-2 cursor-pointer hover:bg-gray-100" onClick={() => handleSelectSalutation(item)}>  {item}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <label htmlFor="firstname" className={labelClass}>First Name</label>
                    <input type="text" id="firstname" placeholder="Gokul" className={inputClass} style={gradientBorderStyles} onChange={(e) => setFirstName(e.target.value)} />
                  </div>
                  <div>
                    <label htmlFor="lastname" className={labelClass}>Last Name</label>
                    <input type="text" id="lastname" placeholder="Ajith" className={inputClass} style={gradientBorderStyles} onChange={(e) => setLastName(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6">
              <div className={getInputContainerClass(2)}>
                <div>
                  <label htmlFor="companyName" className={labelClass}>  Company Name  </label>
                  <input type="text" id="companyName" className={inputClass} style={gradientBorderStyles} placeholder="Company Name" onChange={(e) => setCompanyName(e.target.value)} />
                </div>
                <div>
                  <label htmlFor="displayName" className={labelClass}>Display Name</label>
                  <div className="relative" ref={displayNameRef}>
                    <div>
                      <input type="text"
                        value={displayName}
                        onClick={handleDisplayNameDropdownToggle}
                        readOnly
                        className={`${inputClass} cursor-pointer`}
                        style={gradientBorderStyles}
                        placeholder="Select Display Name" />
                    </div>
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handleDisplayNameDropdownToggle}>
                      <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isDisplayNameDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isDisplayNameDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {displayNameOptions.map((option) => (
                          <div key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectDisplayName(option)}>
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6">
              <div className={getInputContainerClass(3)}>
                <div>
                  <label htmlFor="firstname" className={labelClass}>Email Address</label>
                  <input type="text" id="firstname" placeholder="gklajit@gmail.com" className={inputClass} style={gradientBorderStyles} onChange={(e) => setEmail(e.target.value)}  />
                </div>
                <div>
                  <label htmlFor="firstname" className={labelClass}>Work Phone</label>
                  <input type="text" id="firstname" placeholder="9899999992" className={inputClass} style={gradientBorderStyles} onChange={(e) => setWorkNumber(e.target.value)}/>
                </div>
                <div>
                  <label htmlFor="lastname" className={labelClass}>Mobile Number</label>
                  <input type="text" id="lastname" placeholder="9899999992" className={inputClass} style={gradientBorderStyles} onChange={(e) => setMobileNumber(e.target.value)}/>
                </div>
              </div>
            </div>
            <hr className="mt-10 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)", }} />
            <div className="mb-6 mt-6">
              <div className={getInputContainerClass(2)}>
                <div>
                  <label htmlFor="gstTreatment" className={labelClass}>GST Treatment</label>
                  <div className="relative" ref={gstRef}>
                    <div>
                      <input type="text"
                        value={gstTreatment}
                        onClick={handleGSTDropdownToggle}
                        readOnly
                        className={`${inputClass} cursor-pointer`}
                        style={gradientBorderStyles}
                        placeholder="Select a GST treatment" />
                    </div>
                    <button type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handleGSTDropdownToggle}>
                      <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isGSTDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isGSTDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {gstOptions.map((option) => (
                          <div key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectGST(option)}>
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label htmlFor="placeOfSupply" className={labelClass}>Place of Supply</label>
                  <div className="relative" ref={placeRef}>
                    <div>
                      <input type="text"
                        value={placeOfSupply}
                        onClick={handlePlaceDropdownToggle}
                        readOnly
                        className={`${inputClass} cursor-pointer`}
                        style={gradientBorderStyles}
                        placeholder="Select place of supply" />
                    </div>
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handlePlaceDropdownToggle}>
                      <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isPlaceDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isPlaceDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {placeOptions.map((option) => (
                          <div
                            key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectPlace(option)} >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6">
              <div className={getInputContainerClass(1)}>
                <div>
                  <label htmlFor="lastname" className={labelClass}>PAN</label>
                  <input type="text" id="lastname" placeholder="" className={inputClass} style={gradientBorderStyles} onChange={(e) => setPan(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-6">
              <h4 className="font-montserrat-normal text-xl  font-gray-900 mb-6">Tax Preference</h4>
              <div className="flex items-center space-x-6">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input type="radio" name="customerType" className="w-6 h-6" defaultChecked={taxable} onClick={() => setTaxable(true)}/>
                  <span className="font-montserrat text-base  font-gray-900">Taxable</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input type="radio" name="customerType" className="w-6 h-6" onClick={() => setTaxable(false)} />
                  <span className="font-montserrat text-base  font-gray-900">Tax Exempt</span>
                </label>
              </div>
            </div>
            <div className="mb-6">
              <div className={getInputContainerClass(3)}>
                <div>
                  <label htmlFor="currency" className={labelClass}>Currency</label>
                  <div className="relative" ref={currencyRef}>
                    <div>
                      <input type="text"
                        value={currency}
                        onClick={handleCurrencyDropdownToggle}
                        readOnly
                        className={`${inputClass} cursor-pointer`}
                        style={gradientBorderStyles}
                        placeholder="Select Currency" />
                    </div>
                    <button type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handleCurrencyDropdownToggle}>
                      <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isCurrencyDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isCurrencyDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {currencyOptions.map((option) => (
                          <div key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectCurrency(option)} >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label htmlFor="openingBalance" className={labelClass}>Opening Balance</label>
                  <input type="number" id="openingBalance" placeholder="Opening Bal" className={inputClass} style={gradientBorderStyles} onChange={(e) => setOpeningBal(Number(e.target.value))} />
                </div>
                <div>
                  <label htmlFor="paymentTerms" className={labelClass}>Payment Terms</label>
                  <div className="relative" ref={paymentTermsRef}>
                    <div>
                      <input
                        type="text"
                        value={paymentTerms}
                        onClick={handlePaymentTermsDropdownToggle}
                        readOnly
                        className={`${inputClass} cursor-pointer`}
                        style={gradientBorderStyles}
                        placeholder="Select Payment Terms" />
                    </div>
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handlePaymentTermsDropdownToggle}>
                      <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isPaymentTermsDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isPaymentTermsDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {paymentTermsOptions.map((option) => (
                          <div
                            key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectPaymentTerms(option)}>
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-10 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)", }} />
            <div className="mb-6">
              <div className="flex justify-between items-center mb-6">
                <div className="flex items-center space-x-4">
                  <span className="font-montserrat text-xl  font-gray-900">Enable Portal?</span>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="portalEnable" className="w-4 h-4" checked={enablePortal} onClick={() => setEnablePortal(!enablePortal)}/>
                    <span className="font-montserrat text-sm  font-gray-900">Allow portal for this customer</span>
                  </label>
                </div>
                <div>
                  <span className="font-montserrat text-xl  font-gray-900">Portal Language</span>
                </div>
                <div className="w-60 mt-10">
                  <label htmlFor="portalLanguage" className={labelClass}>Portal Language</label>
                  <div className="relative" ref={portalLanguageRef}>
                    <input
                      type="text"
                      value={portalLanguage}
                      onClick={handlePortalLanguageToggle}
                      readOnly
                      className={`${inputClass} cursor-pointer`}
                      style={gradientBorderStyles}
                      placeholder="Select Portal Language"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handlePortalLanguageToggle}
                    >
                      <img
                        src="/images/desktop/light-arrow-drop-down.svg"
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isPortalLanguageOpen ? 'rotate-180' : ''}`}
                      />
                    </button>
                    {isPortalLanguageOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {languageOptions.map((option) => (
                          <div
                            key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectPortalLanguage(option)}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-6 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)", }} />
            <h4 className="font-montserrat text-lg mt-6 mb-4">Billing Address</h4>
            <div className={getInputContainerClass(2)}>
      <div>
        <label htmlFor="attention" className={labelClass}>Attention</label>
        <input 
          type="text" 
          id="attention" 
          className={inputClass} 
          style={gradientBorderStyles} 
          placeholder="Attention" 
          onChange={(e) => setAttention(e.target.value)} 
        />
      </div>
      <div>
        <label htmlFor="country" className={labelClass}>Country</label>
        <div className="relative" ref={countryRef}>
          <input
            type="text"
            value={country}
            onClick={handleCountryToggle}
            readOnly
            className={`${inputClass} cursor-pointer`}
            style={gradientBorderStyles}
            placeholder="Select Country"
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2"
            onClick={handleCountryToggle}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
              alt="Dropdown Arrow"
              className={`w-7 h-7 transition-transform ${isCountryOpen ? 'rotate-180' : ''}`}
            />
          </button>
          {isCountryOpen && (
            <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10 max-h-60 overflow-y-auto">
              {countries.map(({ code, name }) => (
                <div
                  key={code}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center"
                  onClick={() => handleSelectCountry(code, name)}
                >
                  <img 
                    src={(countriesData as CountriesData)[code].flag} 
                    alt={`${name} flag`} 
                    className="w-6 h-4 mr-2"
                  />
                  <span>{name}</span>
                  <span className="text-gray-500 ml-2">({code})</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>

            <div className="mt-4">
              <label htmlFor="address" className={labelClass}>Address</label>
              <textarea
                id="address"
                className={`${inputClass} w-[80%] h-22 resize-none`}
                style={gradientBorderStyles}
                placeholder="Enter address" 
                onChange={(e) => setPrimaryAddress(e.target.value)} />
              <textarea
                id="address"
                className={`${inputClass} w-[80%] h-22 mt-4 resize-none`}
                style={gradientBorderStyles}
                placeholder="Enter address" 
                onChange={(e) => setSecondaryAddress(e.target.value)} />
            </div>
            <div className="mb-2">
              <div className={getInputContainerClass(2)}>
                <div>
                  <label htmlFor="attention" className={labelClass}>City</label>
                  <input
                    type="text"
                    id="city"
                    className={inputClass}
                    style={gradientBorderStyles}
                    placeholder="Enter City"
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="state" className={labelClass}>State</label>
                  <div className="relative" ref={stateRef}>
                    <div>
                      <input
                        type="text"
                        value={selectedState}
                        onClick={handleStateDropdownToggle}
                        className={`${inputClass} cursor-pointer`}
                        readOnly
                        style={gradientBorderStyles}
                        placeholder="Select State"
                      />
                    </div>
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      onClick={handleStateDropdownToggle}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                        alt="Dropdown Arrow"
                        className={`w-7 h-7 transition-transform ${isStateDropdownOpen ? 'rotate-180' : ''}`}
                      />
                    </button>
                    {isStateDropdownOpen && (
                      <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                        {stateOptions.map((option) => (
                          <div
                            key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelectState(option)}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <div className={getInputContainerClass(1)}>
                <div>
                  <label htmlFor="lastname" className={labelClass}>Phone</label>
                  <input type="text" id="lastname" placeholder="9999900000" className={inputClass} style={gradientBorderStyles} onChange={(e) => setBillingPhoneNo(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center h-full">
            <button 
  onClick={handleSave} 
  disabled={isLoading}
  className={`
    text-center p-3 text-white 
    ${isLoading 
      ? 'bg-gray-400 cursor-not-allowed' 
      : 'bg-gradient-to-r from-[#3483BE] to-[#02385E] hover:bg-gray-50'
    } 
    mt-5 mb-5 rounded-3xl font-medium
  `}
>
  {isLoading ? 'Saving...' : 'Save Customer'}
</button>
          </div>
        </div>
      </div>
      {showToast && (
  <Toast 
    message={toastMessage}
    isError={
      toastMessage.includes('Error') || 
      toastMessage.includes('Cannot') || 
      toastMessage.includes('Failed')
    }
    show={showToast}
    onClose={() => setShowToast(false)}
  />
)}
    </div>


  );
};

export default AccountNewCustomer;
